import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      "sectionRequired": "Zorunlu",
      "sectionVariety": "Karakter çeşitliliği",
      "varietyHint": "4 gruptan en az 3'ü",
      "optionalTag": "isteğe bağlı",
      "notReadyWarning": "Şifreniz değiştirmek için henüz uygun değil. Lütfen yukarıdaki gereksinimlere dikkat ederek şifre oluşturun.",
      "stepVerify": "Kimlik doğrulama",
      "stepNewPassword": "Yeni şifre",
      "verifyMethodQuestion": "Kimliğinizi nasıl doğrulamak istersiniz?",
      "verifyMethodSms": "SMS ile",
      "verifyMethodEmail": "E-posta ile",
      "verifyMethodCurrent": "Mevcut şifremle",
      "currentPasswordHint": "Mevcut şifrenizi biliyorsanız SMS beklemenize gerek yok. Kullanıcı adınız, mevcut şifreniz ve yeni şifreniz yeterlidir.",
      "emailCodeHint": "Doğrulama kodu, hesabınızda kayıtlı e-posta adresine gönderilecektir.",
      "labelCurrentPassword": "Mevcut şifreniz",
      "buttonGeneratePassword": "Benim için güçlü şifre oluştur",
      "tooltipCopyPassword": "Şifreyi panoya kopyala",
      "tooltipShowPassword": "Şifreyi göster",
      "tooltipHidePassword": "Şifreyi gizle",
      "verifyingInProgress": "Doğrulanıyor, lütfen bekleyiniz...",
      "changingInProgress": "Şifreniz değiştiriliyor, lütfen bekleyiniz...",
      "changingOverlayTitle": "Şifreniz değiştiriliyor...",
      "changingOverlayHint": "Lütfen sayfayı kapatmayınız ve tekrar tıklamayınız.",
      "passwordsDoNotMatch": "Şifreler birbiriyle eşleşmiyor.",
      "toastGenerated": "Şifre oluşturuldu ve panoya kopyalandı. Kaydetmeyi unutmayınız.",
      "toastGeneratedNoCopy": "Şifre oluşturuldu. Lütfen not almayı unutmayınız.",
      "toastCopied": "Şifre panoya kopyalandı.",
      "toastCopyFailed": "Kopyalanamadı, lütfen elle seçiniz.",
      "reqNoTurkish": "Türkçe karakter içermiyor (ç ğ ı İ ö ş ü)",
      "reqTurkishUsed": "Türkçe karakter kullanılamaz",
      "reqNoSpace": "Boşluk içermiyor",
      "reqNoUsernameShort": "Kullanıcı adınızı içermiyor",
      "reqNoNameShort": "Adınızı içermiyor",
      "reqNoSurnameShort": "Soyadınızı içermiyor",
      "reqNoTcShort": "TC kimlik numaranızı içermiyor",
      "categoryTitleMet": "Karakter çeşitliliği yeterli",
      "categoryTitleNeed": "Şu 4 gruptan en az 3'ünü kullanınız",
      "catUpper": "Büyük harf (A-Z)",
      "catLower": "Küçük harf (a-z)",
      "catDigit": "Rakam (0-9)",
      "catPunct": "Noktalama (! ? . - _ @)",
      "progressLabel": "İlerleme",
      "allRequirementsMet": "Şifreniz kurallara uygun",
      "someRequirementsMissing": "Eksik gereksinimler var",
      "tick": "✔",
      "cross": "✖",
      "logoAlt": "Lokman Hekim Üniversitesi",
      "infoText1": "Bu sayfadan sadece Wi-Fi, Microsoft Office, E-Posta ve Bilgisayar şifrelerini değiştirebilirsiniz",
      "infoText2": "",
      "landingStudentTitle": "Öğrenci",
      "landingStudentSubtitle": "Öğrenci Şifre Değişikliği",
      "landingPersonnelTitle": "Personel",
      "landingPersonnelSubtitle": "Personel Şifre Değişikliği",
      "landingAuthorityTitle": "Yetkili",
      "landingAuthoritySubtitle": "Bilgi İşlem Yönetim Paneli",
      "footer": "Lokman Hekim Üniversitesi - Bilgi İşlem Daire Başkanlığı © 2025. All rights reserved.",
      "formPageTitleStudent": "Öğrenci Şifre Değiştirme",
      "formPageTitlePersonnel": "Personel Şifre Değiştirme",
      "warningText": "• Şifre değişikliğinin yapılabilmesi için verdiğiniz bilgilerin doğru olduğundan emin olunuz.\n\n• Şifre değişikliği sonrası <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>E-Posta, Bilgisayar, Microsoft Office ve Wi-Fi</span> hesap şifreleriniz de otomatik olarak değişecektir.",
      "warningText2": "<span style='text-decoration: underline; text-decoration-color: rgb(202, 98, 56); color:rgb(202, 98, 56);'>Dikkat:</span> Microsoft Office uygulamaları için şifre değişikliği <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>30 dakika</span> sürebilmektedir.",
      "labelUsernameStudent": "Öğrenci Numarası",
      "labelUsernamePersonnel": "Kullanıcı Adı",
      "labelTC": "TC Kimlik No",
      "labelPhone": "Telefon",
      "buttonVerify": "Doğrula ve SMS Gönder",
      "labelVerificationCode": "Doğrulama Kodu",
      "labelNewPassword": "Yeni Şifre",
      "labelNewPasswordConfirm": "Yeni Şifre (Tekrar)",
      "buttonChangePassword": "Şifreyi değiştir",
      "errorPasswordMismatch": "Hata: Yeni şifreler uyuşmuyor.",
      "resultTitle": "Sonuç:",
      "errorFetch": "Hata: ",
      "verificationSection": "Kullanıcı Doğrulama",
      "changePasswordSection": "Şifre Değiştir",
      // Yeni eklenen metinler:
      "phoneWarning": "Numaranızı başına 0 koymadan, 5xxxxxxxxx formatında giriniz.",
      "passwordRequirementMinLength": "En az 8 karakter",
      "passwordRequirementsTitle": "Şifre Gereksinimleri",
      "passwordRequirementUppercase": "En az bir büyük harf",
      "passwordRequirementLowercase": "En az bir küçük harf",
      "passwordRequirementDigit": "En az bir rakam",
      "passwordRequirementSpecialChar": "En az bir noktalama işareti (örneğin !@#$%^&*(),.?\":{}|<>)",
      "passwordRequirementNoUsername": "Kullanıcı adınızın üç veya daha fazla ardışık karakterlik bölümünü içermemeli",
      "passwordRequirementNoName": "İsminizi içermemeli",
      "passwordRequirementNoSurname": "Soyisminizi içermemeli",
      "passwordRequirementAllPassed": "Şifreniz değiştirmek için uygun.",
      "changePasswordSuccess": "Şifre değiştirme işlemi başarıyla tamamlanmıştır.",
      "errorAdChange": "AD şifresi değiştirilemedi. Google şifresi güncellenmedi."
    }
  },
  en: {
    translation: {
      "sectionRequired": "Required",
      "sectionVariety": "Character variety",
      "varietyHint": "at least 3 of 4 groups",
      "optionalTag": "optional",
      "notReadyWarning": "Your password is not ready yet. Please create a password that meets the requirements above.",
      "stepVerify": "Identity check",
      "stepNewPassword": "New password",
      "verifyMethodQuestion": "How would you like to verify your identity?",
      "verifyMethodSms": "By SMS",
      "verifyMethodEmail": "By e-mail",
      "verifyMethodCurrent": "With my current password",
      "currentPasswordHint": "If you know your current password there is no need to wait for an SMS. Your username, current password and new password are enough.",
      "emailCodeHint": "The verification code will be sent to the e-mail address registered to your account.",
      "labelCurrentPassword": "Current password",
      "buttonGeneratePassword": "Generate a strong password for me",
      "tooltipCopyPassword": "Copy password to clipboard",
      "tooltipShowPassword": "Show password",
      "tooltipHidePassword": "Hide password",
      "verifyingInProgress": "Verifying, please wait...",
      "changingInProgress": "Changing your password, please wait...",
      "changingOverlayTitle": "Changing your password...",
      "changingOverlayHint": "Please do not close the page or click again.",
      "passwordsDoNotMatch": "Passwords do not match.",
      "toastGenerated": "Password generated and copied to clipboard. Remember to save it.",
      "toastGeneratedNoCopy": "Password generated. Please make a note of it.",
      "toastCopied": "Password copied to clipboard.",
      "toastCopyFailed": "Could not copy, please select manually.",
      "reqNoTurkish": "No Turkish characters (ç ğ ı İ ö ş ü)",
      "reqTurkishUsed": "Turkish characters are not allowed",
      "reqNoSpace": "No spaces",
      "reqNoUsernameShort": "Does not contain your username",
      "reqNoNameShort": "Does not contain your first name",
      "reqNoSurnameShort": "Does not contain your surname",
      "reqNoTcShort": "Does not contain your ID number",
      "categoryTitleMet": "Character variety is sufficient",
      "categoryTitleNeed": "Use at least 3 of these 4 groups",
      "catUpper": "Uppercase (A-Z)",
      "catLower": "Lowercase (a-z)",
      "catDigit": "Digit (0-9)",
      "catPunct": "Punctuation (! ? . - _ @)",
      "progressLabel": "Progress",
      "allRequirementsMet": "Your password meets the rules",
      "someRequirementsMissing": "Some requirements are missing",
      "tick": "✔",
      "cross": "✖",
      "logoAlt": "Lokman Hekim University",
      "infoText1": "You can change only your Wi-Fi, Microsoft Office, E-Mail and Computer passwords from this page",
      "infoText2": "",
      "landingStudentTitle": "Student",
      "landingStudentSubtitle": "Student Password Change",
      "landingPersonnelTitle": "Personnel",
      "landingPersonnelSubtitle": "Personnel Password Change",
      "landingAuthorityTitle": "Authority",
      "landingAuthoritySubtitle": "IT Admin Panel",
      "footer": "Lokman Hekim University - IT Department © 2025. All rights reserved.",
      "formPageTitleStudent": "Student Password Change",
      "formPageTitlePersonnel": "Personnel Password Change",
      "warningText": "• Please ensure that the information you provided is correct to change your password.<br/>• After changing your password, your E-Mail, Computer, Microsoft Office, and Wi-Fi account passwords will be updated automatically.",
      "warningText2": "<span style='text-decoration: underline; text-decoration-color: rgb(202, 98, 56); color: rgb(202, 98, 56);'>Attention:</span> Changing the password for Microsoft Office applications may take up to <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>30 minutes</span>.",
      "labelUsernameStudent": "Student Number",
      "labelUsernamePersonnel": "Username",
      "labelTC": "ID Number",
      "labelPhone": "Phone",
      "buttonVerify": "Verify and Send SMS",
      "labelVerificationCode": "Verification Code",
      "labelNewPassword": "New Password",
      "labelNewPasswordConfirm": "New Password (Confirm)",
      "buttonChangePassword": "Change password",
      "errorPasswordMismatch": "Error: The new passwords do not match.",
      "resultTitle": "Result:",
      "errorFetch": "Error: ",
      "verificationSection": "User Verification",
      "changePasswordSection": "Change Password",
      // Yeni eklenen metinler:
      "phoneWarning": "Please enter your phone number without leading 0, in the format 5xxxxxxxxx.",
      "passwordRequirementMinLength": "At least 8 characters",
      "passwordRequirementsTitle": "Password Requirements",
      "passwordRequirementUppercase": "At least one uppercase letter",
      "passwordRequirementLowercase": "At least one lowercase letter",
      "passwordRequirementDigit": "At least one digit",
      "passwordRequirementSpecialChar": "At least one special character (e.g., !@#$%^&*(),.?\":{}|<>)",
      "passwordRequirementNoUsername": "Should not contain three or more consecutive characters from your username",
      "passwordRequirementNoName": "Should not contain your first name",
      "passwordRequirementNoSurname": "Should not contain your last name",
      "passwordRequirementAllPassed": "Your password meets all requirements.",
      "changePasswordSuccess": "Password change was successful.",
      "errorAdChange": "AD password could not be changed. Google password was not updated."
    }
  },
  ar: {
    translation: {
      "sectionRequired": "إلزامي",
      "sectionVariety": "تنوع الأحرف",
      "varietyHint": "3 على الأقل من 4 مجموعات",
      "optionalTag": "اختياري",
      "notReadyWarning": "كلمة المرور غير صالحة بعد. يرجى إنشاء كلمة مرور تستوفي المتطلبات أعلاه.",
      "stepVerify": "التحقق من الهوية",
      "stepNewPassword": "كلمة مرور جديدة",
      "verifyMethodQuestion": "كيف تريد التحقق من هويتك؟",
      "verifyMethodSms": "عبر الرسائل القصيرة",
      "verifyMethodEmail": "عبر البريد الإلكتروني",
      "verifyMethodCurrent": "بكلمة المرور الحالية",
      "currentPasswordHint": "إذا كنت تعرف كلمة المرور الحالية فلا حاجة لانتظار رسالة قصيرة. اسم المستخدم وكلمة المرور الحالية والجديدة تكفي.",
      "emailCodeHint": "سيتم إرسال رمز التحقق إلى البريد الإلكتروني المسجل في حسابك.",
      "labelCurrentPassword": "كلمة المرور الحالية",
      "buttonGeneratePassword": "أنشئ لي كلمة مرور قوية",
      "tooltipCopyPassword": "نسخ كلمة المرور",
      "tooltipShowPassword": "إظهار كلمة المرور",
      "tooltipHidePassword": "إخفاء كلمة المرور",
      "verifyingInProgress": "جارٍ التحقق، يرجى الانتظار...",
      "changingInProgress": "جارٍ تغيير كلمة المرور، يرجى الانتظار...",
      "changingOverlayTitle": "جارٍ تغيير كلمة المرور...",
      "changingOverlayHint": "يرجى عدم إغلاق الصفحة أو النقر مرة أخرى.",
      "passwordsDoNotMatch": "كلمتا المرور غير متطابقتين.",
      "toastGenerated": "تم إنشاء كلمة المرور ونسخها. لا تنس حفظها.",
      "toastGeneratedNoCopy": "تم إنشاء كلمة المرور. يرجى تدوينها.",
      "toastCopied": "تم نسخ كلمة المرور.",
      "toastCopyFailed": "تعذر النسخ، يرجى التحديد يدويًا.",
      "reqNoTurkish": "بدون أحرف تركية (ç ğ ı İ ö ş ü)",
      "reqTurkishUsed": "الأحرف التركية غير مسموح بها",
      "reqNoSpace": "بدون مسافات",
      "reqNoUsernameShort": "لا يحتوي على اسم المستخدم",
      "reqNoNameShort": "لا يحتوي على اسمك",
      "reqNoSurnameShort": "لا يحتوي على اسم عائلتك",
      "reqNoTcShort": "لا يحتوي على رقم هويتك",
      "categoryTitleMet": "تنوع الأحرف كافٍ",
      "categoryTitleNeed": "استخدم 3 على الأقل من هذه المجموعات الأربع",
      "catUpper": "حرف كبير (A-Z)",
      "catLower": "حرف صغير (a-z)",
      "catDigit": "رقم (0-9)",
      "catPunct": "علامة ترقيم (! ? . - _ @)",
      "progressLabel": "التقدم",
      "allRequirementsMet": "كلمة المرور مطابقة للقواعد",
      "someRequirementsMissing": "هناك متطلبات ناقصة",
      "tick": "✔",
      "cross": "✖",
      "logoAlt": "جامعة لقمان حكيم",
      "infoText1": "يمكنك تغيير كلمات مرور Wi‑Fi, Microsoft Office, البريد الإلكتروني والكمبيوتر من هذه الصفحة فقط",
      "infoText2": "",
      "landingStudentTitle": "طالب",
      "landingStudentSubtitle": "تغيير كلمة مرور الطالب",
      "landingPersonnelTitle": "موظف",
      "landingPersonnelSubtitle": "تغيير كلمة مرور الموظف",
      "landingAuthorityTitle": "مسؤول",
      "landingAuthoritySubtitle": "لوحة تحكم تقنية المعلومات",
      "footer": "Lokman Hekim Üniversitesi - Bilgi İşlem Daire Başkanlığı © 2025. All rights reserved.",
      "formPageTitleStudent": "تغيير كلمة مرور الطالب",
      "formPageTitlePersonnel": "تغيير كلمة مرور الموظف",
      "warningText": "• يرجى التأكد من صحة المعلومات التي قدمتها لإجراء تغيير كلمة المرور.\n\n• بعد تغيير كلمة المرور، سيتم تحديث كلمات مرور حسابات البريد الإلكتروني، والكمبيوتر، وMicrosoft Office، وWi‑Fi تلقائياً.",
      "warningText2": "<span style='text-decoration: underline; text-decoration-color: rgb(202, 98, 56); color: rgb(202, 98, 56);'>تنبيه:</span> قد يستغرق تغيير كلمة المرور لتطبيقات Microsoft Office ما يصل إلى <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>30 دقيقة</span>.",
      "labelUsernameStudent": "رقم الطالب",
      "labelUsernamePersonnel": "اسم المستخدم",
      "labelTC": "رقم الهوية",
      "labelPhone": "الهاتف",
      "buttonVerify": "تحقق وأرسل رسالة SMS",
      "labelVerificationCode": "رمز التحقق",
      "labelNewPassword": "كلمة المرور الجديدة",
      "labelNewPasswordConfirm": "تأكيد كلمة المرور الجديدة",
      "buttonChangePassword": "تغيير كلمة المرور",
      "errorPasswordMismatch": "خطأ: كلمات المرور الجديدة غير متطابقة.",
      "resultTitle": "النتيجة:",
      "errorFetch": "خطأ: ",
      "verificationSection": "التحقق من المستخدم",
      "changePasswordSection": "تغيير كلمة المرور",
      // Yeni eklenen metinler:
      "phoneWarning": "Пожалуйста, введите номер телефона без ведущего 0, в формате 5xxxxxxxxx.",
      "passwordRequirementMinLength": "على الأقل 8 أحرف",
      "passwordRequirementsTitle": "متطلبات كلمة المرور",
      "passwordRequirementUppercase": "على الأقل حرف كبير واحد",
      "passwordRequirementLowercase": "على الأقل حرف صغير واحد",
      "passwordRequirementDigit": "على الأقل رقم واحد",
      "passwordRequirementSpecialChar": "على الأقل رمز خاص واحد (مثل !@#$%^&*(),.?\":{}|<>)",
      "passwordRequirementNoUsername": "يجب ألا يحتوي على ثلاثة أحرف متتالية من اسم المستخدم الخاص بك",
      "passwordRequirementNoName": "يجب ألا يحتوي على اسمك الأول",
      "passwordRequirementNoSurname": "يجب ألا يحتوي على اسمك الأخير",
      "passwordRequirementAllPassed": "كلمة المرور تلبي جميع المتطلبات.",
      "changePasswordSuccess": "تم تغيير كلمة المرور بنجاح.",
      "errorAdChange": "لم يتم تغيير كلمة مرور AD. لم يتم تحديث كلمة مرور Google."
    }
  },
  fa: {
    translation: {
      "sectionRequired": "الزامی",
      "sectionVariety": "تنوع نویسه‌ها",
      "varietyHint": "حداقل ۳ مورد از ۴ گروه",
      "optionalTag": "اختیاری",
      "notReadyWarning": "رمز عبور شما هنوز مناسب نیست. لطفاً رمزی بسازید که شرایط بالا را برآورده کند.",
      "stepVerify": "تأیید هویت",
      "stepNewPassword": "رمز عبور جدید",
      "verifyMethodQuestion": "چگونه می‌خواهید هویت خود را تأیید کنید؟",
      "verifyMethodSms": "با پیامک",
      "verifyMethodEmail": "با ایمیل",
      "verifyMethodCurrent": "با رمز عبور فعلی",
      "currentPasswordHint": "اگر رمز عبور فعلی خود را می‌دانید نیازی به انتظار پیامک نیست. نام کاربری، رمز فعلی و رمز جدید کافی است.",
      "emailCodeHint": "کد تأیید به ایمیل ثبت‌شده در حساب شما ارسال خواهد شد.",
      "labelCurrentPassword": "رمز عبور فعلی",
      "buttonGeneratePassword": "یک رمز عبور قوی برایم بساز",
      "tooltipCopyPassword": "کپی رمز عبور",
      "tooltipShowPassword": "نمایش رمز عبور",
      "tooltipHidePassword": "پنهان کردن رمز عبور",
      "verifyingInProgress": "در حال تأیید، لطفاً صبر کنید...",
      "changingInProgress": "در حال تغییر رمز عبور، لطفاً صبر کنید...",
      "changingOverlayTitle": "در حال تغییر رمز عبور...",
      "changingOverlayHint": "لطفاً صفحه را نبندید و دوباره کلیک نکنید.",
      "passwordsDoNotMatch": "رمزهای عبور یکسان نیستند.",
      "toastGenerated": "رمز عبور ساخته و کپی شد. ذخیره‌اش را فراموش نکنید.",
      "toastGeneratedNoCopy": "رمز عبور ساخته شد. لطفاً یادداشت کنید.",
      "toastCopied": "رمز عبور کپی شد.",
      "toastCopyFailed": "کپی نشد، لطفاً دستی انتخاب کنید.",
      "reqNoTurkish": "بدون حروف ترکی (ç ğ ı İ ö ş ü)",
      "reqTurkishUsed": "حروف ترکی مجاز نیست",
      "reqNoSpace": "بدون فاصله",
      "reqNoUsernameShort": "شامل نام کاربری شما نیست",
      "reqNoNameShort": "شامل نام شما نیست",
      "reqNoSurnameShort": "شامل نام خانوادگی شما نیست",
      "reqNoTcShort": "شامل شماره ملی شما نیست",
      "categoryTitleMet": "تنوع نویسه‌ها کافی است",
      "categoryTitleNeed": "حداقل ۳ مورد از این ۴ گروه را به کار ببرید",
      "catUpper": "حرف بزرگ (A-Z)",
      "catLower": "حرف کوچک (a-z)",
      "catDigit": "رقم (0-9)",
      "catPunct": "نشانه‌گذاری (! ? . - _ @)",
      "progressLabel": "پیشرفت",
      "allRequirementsMet": "رمز عبور با قوانین مطابقت دارد",
      "someRequirementsMissing": "برخی شرایط برآورده نشده",
      "tick": "✔",
      "cross": "✖",
      "logoAlt": "دانشگاه لقمان حکیم",
      "infoText1": "شما فقط می‌توانید رمز عبور Wi‑Fi, Microsoft Office, پست الکترونیکی و کامپیوتر خود را از این صفحه تغییر دهید",
      "infoText2": "",
      "landingStudentTitle": "دانشجو",
      "landingStudentSubtitle": "تغییر رمز عبور دانشجو",
      "landingPersonnelTitle": "کارکنان",
      "landingPersonnelSubtitle": "تغییر رمز عبور کارکنان",
      "landingAuthorityTitle": "مسؤول",
      "landingAuthoritySubtitle": "پنل مدیریت فناوری اطلاعات",
      "footer": "Lokman Hekim Üniversitesi - Bilgi İşlem Daire Başkanlığı © 2025. All rights reserved.",
      "formPageTitleStudent": "تغییر رمز عبور دانشجو",
      "formPageTitlePersonnel": "تغییر رمز عبور کارکنان",
      "warningText": "• لطفاً مطمئن شوید اطلاعات وارد شده صحیح است تا تغییر رمز عبور انجام شود.\n\n• پس از تغییر رمز، رمزهای حساب‌های پست الکترونیکی، کامپیوتر، Microsoft Office و Wi‑Fi به‌طور خودکار تغییر خواهند کرد.",
      "warningText2": "<span style='text-decoration: underline; text-decoration-color: rgb(202, 98, 56); color: rgb(202, 98, 56);'>توجه:</span> تغییر رمز عبور برای برنامه‌های Microsoft Office ممکن است تا <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>30 دقیقه</span> طول بکشد.",
      "labelUsernameStudent": "شماره دانشجویی",
      "labelUsernamePersonnel": "نام کاربری",
      "labelTC": "شماره شناسنامه",
      "labelPhone": "تلفن",
      "buttonVerify": "تأیید و ارسال SMS",
      "labelVerificationCode": "کد تأیید",
      "labelNewPassword": "رمز عبور جدید",
      "labelNewPasswordConfirm": "تکرار رمز عبور جدید",
      "buttonChangePassword": "تغییر رمز",
      "errorPasswordMismatch": "خطا: رمزهای جدید مطابقت ندارند.",
      "resultTitle": "نتیجه:",
      "errorFetch": "خطا: ",
      "verificationSection": "تأیید کاربر",
      "changePasswordSection": "تغییر رمز عبور",
      // Yeni eklenen metinler:
            "phoneWarning": "لطفاً شماره تلفن را بدون صفر ابتدایی و در قالب 5xxxxxxxxx وارد کنید.",
      "passwordRequirementMinLength": "حداقل 8 کاراکتر",
      "passwordRequirementsTitle": "الزامات رمز عبور",
      "passwordRequirementUppercase": "حداقل یک حرف بزرگ",
      "passwordRequirementLowercase": "حداقل یک حرف کوچک",
      "passwordRequirementDigit": "حداقل یک عدد",
      "passwordRequirementSpecialChar": "حداقل یک کاراکتر ویژه (مثلاً !@#$%^&*(),.?\":{}|<>)",
      "passwordRequirementNoUsername": "نباید شامل سه کاراکتر متوالی از نام کاربری شما باشد",
      "passwordRequirementNoName": "نباید شامل نام شما باشد",
      "passwordRequirementNoSurname": "نباید شامل نام خانوادگی شما باشد",
      "passwordRequirementAllPassed": "رمز عبور شما تمام الزامات را برآورده می‌کند.",
      "changePasswordSuccess": "عملیات تغییر رمز عبور با موفقیت انجام شد.",
      "errorAdChange": "تغییر رمز عبور AD امکان‌پذیر نبود. رمز عبور Google به‌روزرسانی نشد."
    }
  },
  ru: {
    translation: {
      "sectionRequired": "Обязательно",
      "sectionVariety": "Разнообразие символов",
      "varietyHint": "минимум 3 из 4 групп",
      "optionalTag": "необязательно",
      "notReadyWarning": "Пароль пока не подходит. Пожалуйста, создайте пароль, отвечающий требованиям выше.",
      "stepVerify": "Проверка личности",
      "stepNewPassword": "Новый пароль",
      "verifyMethodQuestion": "Как вы хотите подтвердить личность?",
      "verifyMethodSms": "По SMS",
      "verifyMethodEmail": "По эл. почте",
      "verifyMethodCurrent": "Текущим паролем",
      "currentPasswordHint": "Если вы знаете текущий пароль, ждать SMS не нужно. Достаточно имени пользователя, текущего и нового пароля.",
      "emailCodeHint": "Код подтверждения будет отправлен на адрес эл. почты, указанный в вашей учётной записи.",
      "labelCurrentPassword": "Текущий пароль",
      "buttonGeneratePassword": "Создать надёжный пароль",
      "tooltipCopyPassword": "Скопировать пароль",
      "tooltipShowPassword": "Показать пароль",
      "tooltipHidePassword": "Скрыть пароль",
      "verifyingInProgress": "Проверка, пожалуйста, подождите...",
      "changingInProgress": "Пароль меняется, пожалуйста, подождите...",
      "changingOverlayTitle": "Пароль меняется...",
      "changingOverlayHint": "Не закрывайте страницу и не нажимайте повторно.",
      "passwordsDoNotMatch": "Пароли не совпадают.",
      "toastGenerated": "Пароль создан и скопирован. Не забудьте сохранить его.",
      "toastGeneratedNoCopy": "Пароль создан. Пожалуйста, запишите его.",
      "toastCopied": "Пароль скопирован.",
      "toastCopyFailed": "Не удалось скопировать, выделите вручную.",
      "reqNoTurkish": "Без турецких букв (ç ğ ı İ ö ş ü)",
      "reqTurkishUsed": "Турецкие буквы не допускаются",
      "reqNoSpace": "Без пробелов",
      "reqNoUsernameShort": "Не содержит имя пользователя",
      "reqNoNameShort": "Не содержит ваше имя",
      "reqNoSurnameShort": "Не содержит вашу фамилию",
      "reqNoTcShort": "Не содержит ваш ИНН/номер",
      "categoryTitleMet": "Разнообразие символов достаточное",
      "categoryTitleNeed": "Используйте минимум 3 из 4 групп",
      "catUpper": "Прописная (A-Z)",
      "catLower": "Строчная (a-z)",
      "catDigit": "Цифра (0-9)",
      "catPunct": "Пунктуация (! ? . - _ @)",
      "progressLabel": "Прогресс",
      "allRequirementsMet": "Пароль соответствует правилам",
      "someRequirementsMissing": "Не все требования выполнены",
      "tick": "✔",
      "cross": "✖",
      "logoAlt": "Локман Хеким Университет",
      "infoText1": "Вы можете изменить только пароли Wi‑Fi, Microsoft Office, электронной почты и компьютера с этой страницы",
      "infoText2": "",
      "landingStudentTitle": "Студент",
      "landingStudentSubtitle": "Смена пароля студента",
      "landingPersonnelTitle": "Персонал",
      "landingPersonnelSubtitle": "Смена пароля для персонала",
      "landingAuthorityTitle": "Администратор",
      "landingAuthoritySubtitle": "Панель ИТ-отдела",
      "footer": "Lokman Hekim Üniversitesi - Bilgi İşlem Daire Başkanlığı © 2025. All rights reserved.",
      "formPageTitleStudent": "Смена пароля студента",
      "formPageTitlePersonnel": "Смена пароля для персонала",
      "warningText": "• Пожалуйста, убедитесь, что предоставленная вами информация верна для смены пароля.\n\n• После смены пароля пароли для электронной почты, компьютера, Microsoft Office и Wi‑Fi будут автоматически обновлены.",
      "warningText2": "<span style='text-decoration: underline; text-decoration-color: rgb(202, 98, 56); color: rgb(202, 98, 56);'>Внимание:</span> Смена пароля для приложений Microsoft Office может занять до <span style='text-decoration: underline; text-decoration-color: #0c84cc; color: #0c84cc;'>30 минут</span>.",
      "labelUsernameStudent": "Номер студента",
      "labelUsernamePersonnel": "Имя пользователя",
      "labelTC": "ID номер",
      "labelPhone": "Телефон",
      "buttonVerify": "Проверить и отправить SMS",
      "labelVerificationCode": "Код проверки",
      "labelNewPassword": "Новый пароль",
      "labelNewPasswordConfirm": "Новый пароль (подтверждение)",
      "buttonChangePassword": "Сменить пароль",
      "errorPasswordMismatch": "Ошибка: новые пароли не совпадают.",
      "resultTitle": "Результат:",
      "errorFetch": "Ошибка: ",
      "verificationSection": "Проверка пользователя",
      "changePasswordSection": "Смена пароля",
      // Yeni eklenen metinler:
      "passwordRequirementMinLength": "Минимум 8 символов",
      "passwordRequirementsTitle": "Требования к паролю",
      "passwordRequirementUppercase": "Как минимум одна заглавная буква",
      "passwordRequirementLowercase": "Как минимум одна строчная буква",
      "passwordRequirementDigit": "Как минимум одна цифра",
      "passwordRequirementSpecialChar": "Как минимум один специальный символ (например, !@#$%^&*(),.?\":{}|<>)",
      "passwordRequirementNoUsername": "Не должно содержать три или более последовательных символов из вашего имени пользователя",
      "passwordRequirementNoName": "Не должно содержать ваше имя",
      "passwordRequirementNoSurname": "Не должно содержать вашу фамилию",
      "passwordRequirementAllPassed": "Ваш пароль соответствует всем требованиям.",
      "changePasswordSuccess": "Изменение пароля прошло успешно.",
      "errorAdChange": "Пароль AD не изменён. Пароль Google не обновлён."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'tr',
    resources,
    interpolation: { escapeValue: false }
  });

export default i18n;
